import { toast } from "react-toastify";

const initialState = {
  loading: false,
  error: null,
  list: [],
  updateStatus: false,
};
export default function activation(state = initialState, action) {
  let { type, data } = action;
  switch (type) {
    case "activation/list":
      return { ...state, loading: false, list: data, error: null };
    case "activation/update":
      return { ...state, loading: false, error: null };
    case "activation/updateStatus":
      toast.success("کتاب شما با موفقیت فعال گردید.");
      return { ...state, loading: false, error: null, updateStatus: true };
    case "activation/add":
      toast.success("کتاب شما با موفقیت فعال گردید.");
      return { ...state, loading: false, error: null };
    case "activation/delete":
      return { ...state, loading: false, error: null };
    case "activation/loading":
      return { ...state, loading: true };
    case "activation/error":
      toast.error(data.message);
      return { ...state, loading: false, error: data.message };
    default:
      return state;
  }
}
